module.exports = __webpack_public_path__ + "img/age-verification.663bc497.svg";